import React from 'react'
import PropTypes from 'prop-types'
import { map, size, sortBy } from 'lodash'
import css from 'cape-style'
import { StickyContainer, Sticky } from 'react-sticky'

import DetailMap from './DetailMap'
import LocationList from './LocationList'
import StudentLink from '../Peers/StudentLink'
import Peers from '../Peers/Peers'
import Page from '../Page'
import ImageStack from '../StudentDetail/ImageStack'

import {
  InfoContainer,
  Title,
  Subtitle,
  Description,
  NameLink,
  Divider,
  Loading,
  HideDesktop,
  HideMobile,
  Left,
  Right,
  Wrapper,
  Box,
  Top,
  Reception,
  ProgramHeader,
} from './styles.css'

function AllStudents({ program }) {
  return (
    <StickyContainer>
      <Sticky>
        {({ style }) => (
          <div style={style}>
            <Top bt>Students</Top>
          </div>
        )}
      </Sticky>
      <InfoContainer>
        {size(program) > 0 &&
          map(program, ({ name, students }) => (
            <div>
              <ProgramHeader>{name}</ProgramHeader>
              <Peers students={students} />
            </div>
          ))}
      </InfoContainer>
    </StickyContainer>
  )
}
AllStudents.propTypes = {
  program: PropTypes.objectOf(PropTypes.object).isRequired,
}

function DetailEl({ showGroup, detailClose }) {
  if (!showGroup) {
    return <Loading className="flex loading">loading...</Loading>
  }
  const {
    description,
    extraChild,
    id,
    name,
    lat,
    lng,
    locations,
    program,
    reception,
    show,
    showDate,
    zoom,
    groupType,
  } = showGroup
  const isShowTwo = id === 'recCe80lRL7iU9Fp2'
  const isShowThree = id === 'recsTPYsKxM3gBL7C'
  const isShowFilm = id === 'recfNx1XeiWpMQ8N0'
  const isShowArtstination = id === 'recHdJa0pna3A4ov0'
  const firstShow = show[Object.keys(show)[0]] || null
  const firstStudent =
    (firstShow && firstShow.student && firstShow.student[Object.keys(firstShow.student)[0]]) || null

  return (
    <Page shapeSize="half" shapePos="right" closePopup={detailClose} isInternal>
      <div>
        <detail className={id}>
          <div className="flex">
            <Right>
              <div style={{ minHeight: '33vh' }} />

              <Wrapper>
                <Box shadow>
                  <StickyContainer>
                    <Sticky>
                      {({ style }) => (
                        <div style={style}>
                          <Top>Show Details</Top>
                        </div>
                      )}
                    </Sticky>
                    <InfoContainer>
                      <Title>{name}</Title>
                      {showDate && <Subtitle className="dateRange">{showDate}</Subtitle>}
                      {groupType === 'City Wide' && firstStudent && firstStudent.name && (
                        <Subtitle>{firstStudent.name}</Subtitle>
                      )}
                      {description && (
                        <Description
                          className="description"
                          dangerouslySetInnerHTML={{ __html: description }}
                        />
                      )}
                      {isShowFilm && (
                        <div>
                          for more information check{' '}
                          <a href="https://micafilmmaking.org/">https://micafilmmaking.org/</a>
                        </div>
                      )}
                      {isShowFilm && (
                        <div>
                          <Reception style={css('mb1')}>
                            <p>April 9 & April 10, 6:00 – 10:00 p.m.</p>
                          </Reception>
                        </div>
                      )}
                      {!isShowFilm && reception && (
                        <Reception>
                          <h3>Reception</h3>
                          <p>{reception}</p>
                        </Reception>
                      )}
                      {isShowArtstination && (
                        <Reception>
                          <h3>Reception</h3>
                          <p>TBD</p>
                        </Reception>
                      )}
                      {isShowArtstination && (
                        <Reception>
                          <h3>Symposium “De-Mystifying Public Art”</h3>
                          <p>February 16–17, 2019</p>
                          <p>Marriott Conference Center</p>
                        </Reception>
                      )}
                      {isShowThree && (
                        <Reception>
                          <h3>Tours with Curatorial Fellows</h3>
                          <p>Leaving from Riggs and Leidy Galleries</p>
                          <p>During Opening Reception, 6pm + 7pm</p>
                          <p>Look for the Yellow Umbrellas!</p>
                        </Reception>
                      )}
                    </InfoContainer>
                  </StickyContainer>
                </Box>
              </Wrapper>

              <div style={{ minHeight: '15vh' }} />

              <Wrapper>
                <Box align="flex-end" shadow>
                  <LocationList
                    show={show}
                    reception={reception}
                    isShowFilm={isShowFilm}
                    isShowThree={isShowThree}
                    isShowTwo={isShowTwo}
                    program={program}
                  />
                  {!isShowFilm && extraChild && (
                    <LocationList
                      show={extraChild.show}
                      reception={extraChild.reception}
                      isShowThree={isShowThree}
                      isShowTwo={isShowTwo}
                      program={program}
                    />
                  )}
                </Box>
              </Wrapper>

              <div style={{ minHeight: '15vh' }} />

              {/* {!isShowThree &&
                size(show) > 0 &&
                map(show, ({ documentation }) => (
                  <HideDesktop>
                    <Wrapper width="full">
                      <Box shadow width="full">
                        {documentation && size(documentation) > 0 && (
                          <ImageStack collection={documentation} />
                        )}
                      </Box>
                    </Wrapper>
                  </HideDesktop>
                ))}
              {size(show) > 0 &&
                map(show, ({ documentation }) => (
                  <HideMobile>
                    <Wrapper width="full">
                      <Box shadow width="full">
                        {documentation && size(documentation) > 0 && (
                          <ImageStack collection={documentation} />
                        )}
                      </Box>
                    </Wrapper>
                  </HideMobile>
                ))} */}
            </Right>
            <Left>
              <DetailMap
                defaultCenter={lat ? { lat, lng } : undefined}
                zoom={zoom}
                locations={locations}
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCWW7BwZB4inhmk-k5RWdXRo2pD-5X--YA&v=3.exp&libraries=geometry,drawing,places"
                loadingElement={
                  <div
                    style={{
                      height: '100%',
                      position: 'relative',
                    }}
                  />
                }
                containerElement={
                  <div
                    style={{
                      height: '100%',
                      position: 'relative',
                    }}
                  />
                }
                mapElement={
                  <div
                    style={{
                      top: '0',
                      bottom: '0',
                      left: '0',
                      right: '0',
                      position: 'absolute',
                    }}
                  />
                }
              />
            </Left>
          </div>
        </detail>
      </div>
      <div style={{ minHeight: '33vh' }} />
    </Page>
  )
}
DetailEl.propTypes = {
  showGroup: PropTypes.shape({
    description: PropTypes.string,
    gallery: PropTypes.string,
    lat: PropTypes.number,
    lng: PropTypes.number,
    ongoing: PropTypes.bool,
    program: PropTypes.object.isRequired,
    receptionDate: PropTypes.string,
    showDate: PropTypes.string,
    name: PropTypes.string.isRequired,
    zoom: PropTypes.number,
  }),
  detailClose: PropTypes.func.isRequired,
}
DetailEl.defaultProps = {
  showGroup: null,
}
export default DetailEl
